import { call, put, takeLatest } from 'redux-saga/effects';
import {
  cancelCreditNoteFailure,
  cancelCreditNoteRequest,
  cancelCreditNoteSuccess,
  transmitCNToPeppolFailure,
  transmitCNToPeppolRequest,
  transmitCNToPeppolSuccess,
} from './creditNotesSlice';
import { apiClient } from '../../utils/axios';
import { showSnackbar } from '../snackbarSlice';

function* cancelCreditNoteSaga(action) {
  try {
    const { url, reason } = action.payload;
    const data = { reason };
    const response = yield call(apiClient.put, url, data);
    yield put(cancelCreditNoteSuccess(response.data));
  } catch (error) {
    yield put(cancelCreditNoteFailure(error.response?.data?.errors));
  }
}

function* transmitCNToPeppolSaga(action) {
  try {
    const { documentId } = action.payload;
    const response = yield call(apiClient.get, `/credit-notes/${documentId}/transmit-doc-over-peppol`);

    yield put(transmitCNToPeppolSuccess(response.data));
    yield put(
      showSnackbar({
        message: response.data.message,
        severity: 'success',
      }),
    );
  } catch (error) {
    yield put(transmitCNToPeppolFailure(JSON.stringify(error.message)));
    yield put(showSnackbar({ message: error.response?.data?.message, severity: 'error' }));
  }
}

function* creditNotesSaga() {
  yield takeLatest(cancelCreditNoteRequest.type, cancelCreditNoteSaga);
  yield takeLatest(transmitCNToPeppolRequest.type, transmitCNToPeppolSaga);
}

export default creditNotesSaga;
